/* tslint:disable */
import {
  Lease,
  ChartOfAccount,
  CompanyAccount,
  PropertyUnits
} from '../index';

declare var Object: any;
export interface DiscountInterface {
  "notes": string;
  "fromDate": Date;
  "toDate": Date;
  "isPercentage": boolean;
  "discount": string;
  "id"?: number;
  "leaseId"?: number;
  "chartOfAccountId"?: number;
  "property_id"?: number;
  "property_unit_id"?: number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt"?: Date;
  lease?: Lease;
  chartOfAccount?: ChartOfAccount;
  property?: CompanyAccount;
  propertyUnits?: PropertyUnits;
}

export class Discount implements DiscountInterface {
  "notes": string;
  "fromDate": Date;
  "toDate": Date;
  "isPercentage": boolean;
  "discount": string;
  "id": number;
  "leaseId": number;
  "chartOfAccountId": number;
  "property_id": number;
  "property_unit_id": number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt": Date;
  lease: Lease;
  chartOfAccount: ChartOfAccount;
  property: CompanyAccount;
  propertyUnits: PropertyUnits;
  constructor(data?: DiscountInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Discount`.
   */
  public static getModelName() {
    return "Discount";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Discount for dynamic purposes.
  **/
  public static factory(data: DiscountInterface): Discount{
    return new Discount(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Discount',
      plural: 'Discounts',
      path: 'Discounts',
      idName: 'id',
      properties: {
        "notes": {
          name: 'notes',
          type: 'string'
        },
        "fromDate": {
          name: 'fromDate',
          type: 'Date'
        },
        "toDate": {
          name: 'toDate',
          type: 'Date'
        },
        "isPercentage": {
          name: 'isPercentage',
          type: 'boolean',
          default: false
        },
        "discount": {
          name: 'discount',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "leaseId": {
          name: 'leaseId',
          type: 'number'
        },
        "chartOfAccountId": {
          name: 'chartOfAccountId',
          type: 'number'
        },
        "property_id": {
          name: 'property_id',
          type: 'number'
        },
        "property_unit_id": {
          name: 'property_unit_id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "deletedAt": {
          name: 'deletedAt',
          type: 'Date',
          default: new Date(0)
        },
      },
      relations: {
        lease: {
          name: 'lease',
          type: 'Lease',
          model: 'Lease',
          relationType: 'belongsTo',
                  keyFrom: 'leaseId',
          keyTo: 'id'
        },
        chartOfAccount: {
          name: 'chartOfAccount',
          type: 'ChartOfAccount',
          model: 'ChartOfAccount',
          relationType: 'belongsTo',
                  keyFrom: 'chartOfAccountId',
          keyTo: 'id'
        },
        property: {
          name: 'property',
          type: 'CompanyAccount',
          model: 'CompanyAccount',
          relationType: 'belongsTo',
                  keyFrom: 'property_id',
          keyTo: 'id'
        },
        propertyUnits: {
          name: 'propertyUnits',
          type: 'PropertyUnits',
          model: 'PropertyUnits',
          relationType: 'belongsTo',
                  keyFrom: 'property_unit_id',
          keyTo: 'id'
        },
      }
    }
  }
}
